import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Send } from "lucide-react";

const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ContactForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((er) => ({ ...er, [name]: undefined }));
  };

  const validate = () => {
    const er = {};
    if (!form.name.trim()) er.name = t("contact.errorRequired");
    if (!form.email.trim()) er.email = t("contact.errorRequired");
    else if (!emailRe.test(form.email.trim())) er.email = t("contact.errorEmail");
    if (!form.message.trim()) er.message = t("contact.errorRequired");
    return er;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const er = validate();
    setErrors(er);
    if (Object.keys(er).length) return;
    setSubmitting(true);
    // frontend-only: redirect to thank you
    setTimeout(() => {
      navigate("/thank_you");
    }, 250);
  };

  return (
    <form className="contact-form" onSubmit={onSubmit} data-testid="contact-form" noValidate>
      <div className="field">
        <label htmlFor="cf-name">{t("contact.nameLabel")}</label>
        <input
          id="cf-name"
          name="name"
          type="text"
          value={form.name}
          onChange={handleChange}
          placeholder={t("contact.namePlaceholder")}
          data-testid="cf-name"
          autoComplete="name"
        />
        {errors.name && <span className="field-error">{errors.name}</span>}
      </div>
      <div className="field">
        <label htmlFor="cf-email">{t("contact.emailLabel")}</label>
        <input
          id="cf-email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder={t("contact.emailPlaceholder")}
          data-testid="cf-email"
          autoComplete="email"
        />
        {errors.email && <span className="field-error">{errors.email}</span>}
      </div>
      <div className="field">
        <label htmlFor="cf-message">{t("contact.messageLabel")}</label>
        <textarea
          id="cf-message"
          name="message"
          rows={5}
          value={form.message}
          onChange={handleChange}
          placeholder={t("contact.messagePlaceholder")}
          data-testid="cf-message"
        />
        {errors.message && <span className="field-error">{errors.message}</span>}
      </div>
      <p className="contact-consent">{t("contact.consent")}</p>
      <button className="btn btn-primary btn-lg" type="submit" disabled={submitting} data-testid="cf-submit">
        <Send size={16} /> {submitting ? t("cta.sending") : t("cta.submit")}
      </button>
    </form>
  );
}
